import React from 'react';
import { usePageContext } from '../../hooks/contexts/usePageContext';
import * as styles from './iframeContact.module.scss';

interface IIframeContactProps {
  codePrestataire: string;
  hebergeur?: boolean;
}

const BASEURLHEBERGEUR = {
  fr: 'https://reservation.tours-tourisme.fr/contact-prestataire-hebergeur-iframe.html?id_fiche=',
  en: 'https://booking.tours-tourisme.fr/contact-prestataire-hebergeur-iframe.html?id_fiche=',
};

const BASEURL = {
  fr: 'https://reservation.tours-tourisme.fr/contact-prestataire-iframe.html?id_fiche=',
  en: 'https://booking.tours-tourisme.fr/contact-prestataire-iframe.html?id_fiche=',
};

export const IframeContact = ({ codePrestataire, hebergeur = false }: IIframeContactProps) => {
  const { lang } = usePageContext();
  const url = `${hebergeur ? BASEURLHEBERGEUR[lang] : BASEURL[lang]}${codePrestataire}`;
  const title = `contact-${codePrestataire}`;
  return <iframe className={styles.iframe} src={url} title={title} />;
};
